module.exports = __webpack_public_path__ + "img/unfinished.ab537565.png";